import React, {Component} from 'react'
import * as firebase from 'firebase'
import * as firebaseui from 'firebaseui'

import UserCard from './react/UserCard'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import Messaging from './react/Messaging'
import AppointmentsManager from './react/AppointmentsManager'

import {muiTheme, cardStyles} from './Constants'



export default class Admin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      refereeKey: decodeURIComponent(window.location.pathname.split("/")[1]),
      block: false,
      uid: '',
      displayName: '',
      userEmail: '',
      photoURL: '',
      message: '',
    }
  }

  signOut = () => {
    firebase.auth().signOut().then(function() {
      console.log('Signed Out')
      window.location = 'https://admin.petalslaserlounge.com'
    }, function(error) {
      console.error('Sign Out Error', error)
    })
  }

  render() {
    var self = this

    /**
     * Firebase & Firebase UI initialization variables
     */
    var config = {
      apiKey: "AIzaSyBaCFb5yACF2XePJVfnBGYDAYxncdXCiyM",
      authDomain: "awesome-petals.firebaseapp.com",
      databaseURL: "https://awesome-petals.firebaseio.com",
      projectId: "awesome-petals",
      storageBucket: "awesome-petals.appspot.com",
      messagingSenderId: "701784428235"
    }
    var uiConfig = {
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      signInFlow: 'popup',
      // Terms of service url.
      tosUrl: '<your-tos-url>',
      callbacks: {
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          var user = authResult.user;
          var credential = authResult.credential;
          var isNewUser = authResult.additionalUserInfo.isNewUser;
          var providerId = authResult.additionalUserInfo.providerId;
          var operationType = authResult.operationType;

          var displayName = user.displayName
          var email = user.email
          var photoURL = user.photoURL
          var phoneNumber = user.phoneNumber
          var providerData = user.providerData

          self.setState({
            block: true,
            uid: user.uid,
            displayName: displayName,
            userEmail: email,
            photoURL: photoURL,
          })
          return false
        }
      }
    }
    if(!this.state.block) {
      firebase.initializeApp(config)
    }

    /** Firebase UI Authentication flow & initialization logic
     * User's information is rendered only after loggin in
     */
    if(firebase.auth().currentUser != null) {
      document.getElementById("smalltext").innerHTML="Unleash your Earthly Beauty"
      document.getElementById("index-banner").style.minHeight = '150px'
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.signOut} />,
          <FlatButton
          label="Sign Out"
          primary={true}
          onClick={this.signOut} />
    ];
    document.getElementById("notneeded").style.display = "none"
    let reef = firebase.database().ref("info/admin/authentication/" + firebase.auth().currentUser.uid + "/")
    reef.on("value", function(snap) {
      if(!snap.val()) {
        self.signOut()
      }
    })
      return (
        <div>
        <MuiThemeProvider muiTheme={muiTheme}>
          <div>
            <div className="row">
            <div className="col-6 col-md-4">
              <br/>
              <Messaging
                user={self.state.uid}
                photoURL={self.state.photoURL}
                displayName={self.state.displayName}
                email={self.state.email}
                onCategorySelected={self.onCategorySelected}/>
            </div>
            <div className="col-12 col-md-8">
              <br/>
              <AppointmentsManager
                user={self.state.uid}
                photoURL={self.state.photoURL}
                displayName={self.state.displayName}
                email={self.state.userEmail}
                categoriesSelected={self.state.categoriesSelected}/>
            </div>
          </div>
          </div>
        </MuiThemeProvider>
        </div>
      )
    } else {
      document.getElementById("smalltext").innerHTML="Sign in with your Petals or CitadelNY email to manage appoinments and loyalty rewards"
      let ui = new firebaseui.auth.AuthUI(firebase.auth());
      ui.start('#firebaseui-auth-container', uiConfig)
      return (
        <div className="center">
      </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/Admin.js